import FilterSelector from '@/components/FilterSelector.vue';
import { envName } from '@/env';
import { FrameStore } from "@/modules/base";
import { defaultParams, MixerType, SspDataModule } from "@/modules/SspDataModule";
import { store } from '@/store';
import { downloadJson, fileDialog, readFileAsText } from '@/utils/file';
import { Component, Prop, Vue } from "vue-property-decorator";
import SdssTrueColor from "./SdssTrueColor.vue";
import SimpleRgb from "./SimpleRgb.vue";
import SimpleColorMatrix from './SimpleColorMatrix.vue'

@Component({
  components: {
    SdssTrueColor,
    SimpleColorMatrix,
    SimpleRgb,
    FilterSelector,
  },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: SspDataModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof SspDataModule>

  get params() {
    return this.frameStore.params
  }

  save() {
    downloadJson(`hscMap-color-setting.json`, this.params)
  }

  async load() {
    const filelist = await fileDialog()
    if (filelist && filelist.length > 0) {
      const file = filelist.item(0)!
      const params = JSON.parse(await readFileAsText(file))
      this.frameStore.params = params
    }
  }

  reset() {
    this.frameStore.params = defaultParams()
  }

  get mixerTypes() {
    return [
      MixerType.SIMPLE_RGB,
      MixerType.SDSS_TRUE_COLOR,
      MixerType.SIMPLE_COLOR_MATRIX,
    ]
  }

  get filters() {
    if (envName === 'public-release-2-chorus' && store.currentFrame.modules.sspData.activeReruns.indexOf('chorus-s18a-da908ee467204a79') < 0) {
      const chorus_filters = ['NB0527', 'NB0718', 'IB0945', 'NB0973']
      return this.Env.filters.filter(f => chorus_filters.indexOf(f.value) < 0)
    }
    return this.Env.filters
  }
}
